import { render } from "./App.vue?vue&type=template&id=3dae9b59"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/scss/general.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__